/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Delivered/view.blocks to change it.
import Check from 'DesignSystem/Svgs/Check/index'
import React from 'react'
import Tag from './Tag/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Delivered({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Outbound/Info/MessageStatus/Delivered",
  onClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="Delivered.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<Check
  viewPath={`${viewPath}/Check`}
 height={10}
 stroke="#00BC70"
 width={10}
/>
<Tag
  viewPath={`${viewPath}/Tag`}
 flowNo={!isHovered}
 flowContent={isHovered}
/>
</button>
{children}
</React.Fragment>)
}